import { useEffect, useState } from 'react';

interface ReadingProgressProps {
  target: React.RefObject<HTMLElement>;
}

export function ReadingProgress({ target }: ReadingProgressProps) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (!target.current) return;

      const windowHeight = window.innerHeight;
      const documentHeight = target.current.scrollHeight;
      const scrollTop = window.scrollY;
      const elementTop = target.current.offsetTop;

      const trackLength = documentHeight - windowHeight;
      const scrolled = scrollTop - elementTop;
      const percentage = (scrolled / trackLength) * 100;

      setProgress(Math.min(Math.max(percentage, 0), 100));
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial calculation

    return () => window.removeEventListener('scroll', handleScroll);
  }, [target]);

  return (
    <div className="fixed top-0 left-0 right-0 z-50 h-1 bg-[#F4F7F9]">
      <div
        className="h-full transition-all duration-150"
        style={{ background: 'linear-gradient(to right, #34AFFB, #1E88E5)', width: `${progress}%` }}
      />
    </div>
  );
}
